// In tiptap v3 the Editor instance exists before (and survives after) its
// EditorContent mounts the view, and any view-backed access (commands.focus,
// isFocused) throws until the view is attached. isDestroyed doubles as the
// mounted check: it reports true whenever the view is absent.
export function isEditorViewMounted(editor) {
  return Boolean(editor && !editor.isDestroyed);
}

/**
 * Determines if the editor content is truly empty.
 * Entity nodes (emoji, mentions) count as content even though they don't contribute to textContent;
 * bare hard breaks don't. Structural nodes (code blocks, lists, blockquotes) count even when empty.
 */
export function isEditorContentEmpty(editor) {
  if (!editor || !editor.state?.doc) return true;

  // Check if document has any structural nodes - these count as content even if empty
  let hasStructuralNode = false;
  editor.state.doc.descendants((node) => {
    if (['codeBlock', 'blockquote', 'bulletList', 'orderedList'].includes(node.type.name)) {
      hasStructuralNode = true;
      return false; // stop traversal
    }
  });

  if (hasStructuralNode) return false;

  if (editor.state.doc.textContent.trim().length > 0) return false;

  // No text: entities (emoji/mentions) still count as content, but bare hard
  // breaks don't — otherwise a lone Shift+Enter would enable the send button.
  let hasNonBreakContent = false;
  editor.state.doc.descendants((node) => {
    if (hasNonBreakContent) return false;
    if (node.isText || ['paragraph', 'hardBreak'].includes(node.type.name)) return true;
    hasNonBreakContent = true;
    return false;
  });

  return !hasNonBreakContent;
}
